'use client';

import { useEffect } from 'react';

export function CalComInit() {
  useEffect(() => {
    // Defer Cal.com initialization until browser is idle
    const initCal = async () => {
      try {
        const { getCalApi } = await import('@calcom/embed-react');
        const cal = await getCalApi({ namespace: '30min' });
        cal('ui', { hideEventTypeDetails: false, layout: 'month_view' });
      } catch (error) {
        console.debug('Cal.com initialization skipped');
      }
    };

    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => initCal(), { timeout: 8000 });
    } else {
      setTimeout(initCal, 5000);
    }
  }, []);

  return null;
}
